export enum STOCK_CHART_PERIOD_LEVELS {
  ONEWEEK = 'W1',
  ONEMONTH = 'M1',
  SIXMONTH = 'M6',
  ONEYEAR = 'Y1',
  FIVEYEAR = 'Y5'
}

export const PERIOD_LABELS: { [key: string]: string } = {
  'W1': '1W',
  'M1': '1M',
  'M6': '6M',
  'Y1': '1Y',
  'Y5': '5Y'
};

export enum Exchanges {
  NSE = "NSE",
  BSE = "BSE",
}
